import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'heading-image',
  templateUrl: './heading-image.component.html',
  styleUrls: ['./heading-image.component.scss'],
})
export class HeadingImageComponent {
  @HostBinding('style.height.px')
  @Input()
  height: number;
}
